import { Action } from "@ngrx/store";

export enum EMigrateActions {
  START_MIGRATION = "[Migration stakeholders] Start migration",
  CANCEL_MIGRATION = "[Migration stakeholders] Cancel migration",
  START_STATUS_DETECTION = "[Migration stakeholders] Start status detection",
  START_STATUS_DETECTION_SUCCESS = "[Migration stakeholders] Start status detection success",
  STOP_STATUS_DETECTION = "[Migration stakeholders] Stop status detection",
  RESET_STATUS_DETECTION = "[Migration stakeholders] Reset status detection",
  SET_STATUS = "[Migration stakeholders] Set status",
  SET_PROGRESS = "[Migration stakeholders] Set progress",
}

export class StartMigration implements Action {
  public readonly type = EMigrateActions.START_MIGRATION;
}

export class CancelMigration implements Action {
  public readonly type = EMigrateActions.CANCEL_MIGRATION;
}

export class StartStatusDetection implements Action {
  public readonly type = EMigrateActions.START_STATUS_DETECTION;
}

export class ResetStatusDetection implements Action {
  public readonly type = EMigrateActions.RESET_STATUS_DETECTION;
}

export class StartStatusDetectionSuccess implements Action {
  public readonly type = EMigrateActions.START_STATUS_DETECTION_SUCCESS;
  constructor(public payload: any) {}
}

export class StopStatusDetection implements Action {
  public readonly type = EMigrateActions.STOP_STATUS_DETECTION;
}

export class SetStatus implements Action {
  public readonly type = EMigrateActions.SET_STATUS;
  constructor(public payload: string) {}
}

export class SetProgress implements Action {
  public readonly type = EMigrateActions.SET_PROGRESS;
  constructor(public payload: IProgressMigration) {}
}

export type MigrateActions =
  | StartMigration
  | CancelMigration
  | StartStatusDetection
  | StartStatusDetectionSuccess
  | StopStatusDetection
  | ResetStatusDetection
  | SetStatus
  | SetProgress;
